<script>
import Swiper from "swiper";
export default {
  name: "ContentSlider",
  mounted() {
    this.$nextTick(() => {
      const { slider, nextEl, prevEl } = this.$refs;
      new Swiper(slider, {
        loop: true,
        initialSlide: 1,
        centeredSlides: true,
        slidesPerView: "auto",
        spaceBetween: 24,
        breakpoints: {
          800: {
            initialSlide: 0,
            centeredSlides: false,
            spaceBetween: 8
          }
        },
        navigation: { nextEl, prevEl }
      });
    });
  }
};
</script>

<style lang="stylus" scoped>
@import "ContentSlider"
</style>
